<template>
  <div>
    <loraInfo />
  </div>
</template>
